import {
  Button,
  CircularProgress,
  IconButton,
  Menu,
  MenuItem,
} from "@material-ui/core";
import { ArrowDropDown } from "@material-ui/icons";
import { Apps } from "@material-ui/icons";
import MenuIcon from "@material-ui/icons/Menu";
import React, { Component, Suspense } from "react";
// import { Route, Switch } from "react-router";
import { Redirect, Route, Switch } from "react-router-dom";
import Information from "../../components/Information";
import "./index.css";
// pages
import Hagholvekaleh from "../../pages/Hagholvekaleh/core";
import KhesaratTakhirTadieh from "../../pages/KhesaratTakhirTadieh";
import { Link } from "react-router-dom";
import Drawer from "./components/Menu";

const pages = [
  {
    title: "محاسبه آنلاین حق الوکاله و تمبر مالیاتی وکلا طبق تعرفه یا قرارداد",
    path: "/hagh-ol-vekaleh",
    // component: "Hagholvekaleh/core/index",
    component: Hagholvekaleh,
    exact: true,
  },
  {
    title:
      "محاسبه آنلاین خسارت تاخیر تادیه چک ، سفته ، دین ، مطالبات و ... بر اساس شاخص بانک مرکزی",
    path: "/khesarat-takhir-tadieh",
    // component: "KhesaratTakhirTadieh/index",
    component: KhesaratTakhirTadieh,
    exact: true,
  },
];

class MainLayout extends Component {
  constructor() {
    super();
    this.state = {
      showPages: null,
      showDrawer: false,
    };
  }

  setShowDrawer = () => {
    this.setState({ showDrawer: !this.state.showDrawer });
  };
  setShowPages = (value) => {
    this.setState({ showPages: value });
  };
  handleClick = (event) => {
    this.setShowPages(event.currentTarget);
  };

  handleClose = () => {
    this.setShowPages(null);
  };

  render() {
    const { showPages, showDrawer } = this.state;
    return (
      <div className="MainLayout">
        <nav>
          <IconButton onClick={this.setShowDrawer}>
            <MenuIcon />
          </IconButton>
        </nav>
        <Drawer open={showDrawer} onClose={this.setShowDrawer} />
        <Suspense fallback={<CircularProgress />}>
          <Switch>
            {pages.map((item, index) => (
              <Route
                key={index}
                exact={item.exact}
                path={item.path}
                component={item.component}
              />
            ))}
            <Redirect from="/" to="/khesarat-takhir-tadieh" />
          </Switch>
        </Suspense>
        <Information />
      </div>
    );
  }
}

export default MainLayout;
